import {
  InactivityTimeoutOption,
  SessionDurationOption,
  SessionPolicyOption,
} from "./types";

export const SESSION_POLICY_OPTIONS: SessionPolicyOption[] = [
  {
    value: "true",
    label: "Persistent",
    id: "persistent",
    helperText:
      "Users remain signed in even after closing and reopening their browser",
  },
  {
    value: "false",
    label: "Non-persistent",
    id: "non-persistent",
    helperText:
      "Users must log in each time they close and reopen their browser",
  },
];

export const SESSION_DURATION_MINUTES_OPTIONS: SessionDurationOption[] = [
  { label: "14 Days", value: 20160 },
  { label: "7 Days", value: 10080 },
  { label: "1 Day", value: 1440 },
  { label: "12 Hours", value: 720 },
  { label: "8 Hours", value: 480 },
  { label: "6 Hours", value: 360 },
  { label: "1 Hour", value: 60 },
  { label: "30 Minutes", value: 30 },
];

export const INACTIVITY_PERIOD_MINUTES_OPTIONS: InactivityTimeoutOption[] = [
  { label: "5 Minutes", value: 5 },
  { label: "15 Minutes", value: 15 },
  { label: "30 Minutes", value: 30 },
  { label: "1 Hour", value: 60 },
  { label: "2 Hours", value: 120 },
];
